import { buyOffer as e } from "../../../pages/checkout/api/index.mjs";
const t = (f, r) => e(f, r);
export {
  t as xenditBuyOffer
};
